// Enum values that match the backend C# enums

// PodcastStatus enum values (must match backend Database/Models/PodcastStatus.cs)
export const PodcastStatusEnum = {
  Draft: 0,
  Processing: 1,
  Completed: 2,
  Failed: 3,
} as const

export type PodcastStatusValue = typeof PodcastStatusEnum[keyof typeof PodcastStatusEnum]

// Helper to check if a value is a valid podcast status
export const isValidPodcastStatus = (value: unknown): value is PodcastStatusValue => {
  return typeof value === 'number' && Object.values(PodcastStatusEnum).includes(value as PodcastStatusValue)
}
